<template>
    <b-modal
        id="disabilitiesModal"
        ref="modal"
        :title="$t('Assign disabilities')"
        no-close-on-backdrop
        scrollable
        size="xl"
        @close="form.reset()"
        @show="fetchData()"
    >
        <template #modal-footer>
            <b-button :disabled="disabled" type="submit" variant="primary" @click="handleSubmit">
                {{ $t('Save') }}

                <b-spinner v-if="form.busy" small/>
                <fa v-else class="ml-1" icon="save"/>
            </b-button>
        </template>

        <b-form @submit.prevent="handleSubmit">
            <b-form-group
                :invalid-feedback="form.errors.get('disability_id')"
                :label="$t('Disability')"
                :state="form.errors.has('disability_id') ? false : null"
                label-for="disability_id"
            >
                <resource-select
                    id="disability_id"
                    v-model="disabilities"
                    multiple
                    resource="disabilities"
                />
            </b-form-group>

            <file-upload-form-group
                v-model="form.images"
                :invalid-feedback="imageErrors.join('<br>')"
                :progress="form.progress"
                :state="form.errors.any() ? false : null"
                accept="image/*"
            />

            <b-form-group
                :invalid-feedback="form.errors.get('notice')"
                :label="$t('Notice')"
                :state="form.errors.has('notice') ? false : null"
                label-for="notice"
            >
                <b-form-textarea
                    id="notice"
                    v-model="form.notice"
                    :state="form.errors.has('notice') ? false : null"
                    name="notice"
                />
            </b-form-group>

            <tree-view
                v-model="form.rooms"
                :errors="form.errors"
                :items="items"
                :loading="pending"
                class="mt-3"
                error-prefix="rooms"
            />
        </b-form>
    </b-modal>
</template>
<script>
import fetchData from "@/mixins/fetchData";
import ResourceSelect from "@/components/selects/ResourceSelect";
import FileUploadFormGroup from "@/components/FileUploadFormGroup";
import TreeView from "@/components/TreeView";
import Form from '@/plugins/form'
import {cloneDeep} from "lodash";

export default {
    name: 'AssignDisabilities',
    components: {TreeView, FileUploadFormGroup, ResourceSelect},
    mixins: [fetchData],
    props: {
        projectId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            lazy: true,
            form: new Form({
                rooms: [],
                notice: null,
                images: [],
            }),
            disabilities: []
        }
    },
    computed: {
        apiUrl() {
            return `/api/projects/${this.projectId}/rooms`
        },
        disabled() {
            return this.form.busy || !this.disabilities.length || !this.form.rooms.length
        },
        imageErrors() {
            let errors = this.form.errors.all();
            errors = Object.keys(errors)
                .filter(key => key.includes('images'))
                .reduce((obj, key) => {
                    obj[key] = errors[key];
                    return obj;
                }, {});

            return Object.values(errors).reduce((a, b) => a.concat(b), [])
        }
    },
    methods: {
        async handleSubmit() {
            if (this.disabled) return;

            const disabilities = cloneDeep(this.disabilities);

            try {
                for (const disabilityIndex in disabilities) {
                    const disability = disabilities[disabilityIndex]

                    await this.form.post(`/api/disabilities/${disability.id}/rooms/assign`);
                    this.disabilities.splice(disabilityIndex, 1)
                }

                this.$root.$emit('disabilities-assigned')

                this.savedToast();
                this.form.reset();

                this.$refs.modal.hide();
            } catch (e) {
                e.response || throw e;
            }
        },

    }

}
</script>
